export const makeShort = (string: string, count = 30) =>
    string.length > count ? string.slice(0, count) + '...' : string;
